import Link from "next/link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

export default function HomePage() {
  return (
    <div className="flex flex-1 items-center justify-center p-8">
      <div className="grid gap-6 max-w-lg w-full">
        <Card>
          <CardHeader>
            <CardTitle>FA 固定资产明细</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-zinc-500 mb-4">
              查询固定资产明细数据，支持筛选、统计汇总和导出
            </p>
            <Link
              href="/fa-details"
              className="inline-flex h-9 items-center justify-center rounded-md bg-zinc-900 px-4 text-sm font-medium text-white hover:bg-zinc-800 dark:bg-zinc-50 dark:text-zinc-900 dark:hover:bg-zinc-200"
            >
              进入查询
            </Link>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle>CRM 客户联系人变更</CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-zinc-500 mb-4">
              查询客户联系人变更数据，支持筛选、统计汇总和导出
            </p>
            <Link
              href="/crm-contacts"
              className="inline-flex h-9 items-center justify-center rounded-md bg-zinc-900 px-4 text-sm font-medium text-white hover:bg-zinc-800 dark:bg-zinc-50 dark:text-zinc-900 dark:hover:bg-zinc-200"
            >
              进入查询
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}